import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import css from './dialog.module.scss';
import { useLang } from '@/app/utils/useLang';

interface Props {
    open: boolean;
    onClose: () => void;
}

const Dialog: React.FC<Props> = ({ open, onClose }) => {
    const { t } = useLang('dpux.App.dialog');
    const list = [
        {
            title: t('item_1_title'),
            children: [
                {
                    title: t('item_1_1_title'),
                    children: [
                        t('item_1_1_desc1'),
                        t('item_1_1_desc2'),
                        t('item_1_1_desc3'),
                        t('item_1_1_desc4'),
                        t('item_1_1_desc5'),
                        t('item_1_1_desc6'),
                        t('item_1_1_desc7'),
                        t('item_1_1_desc8'),
                    ],
                },
                {
                    title: t('item_1_2_title'),
                    children: [t('item_1_2_desc1'), t('item_1_2_desc2'), t('item_1_2_desc3'), t('item_1_2_desc4')],
                },
                {
                    title: t('item_1_3_title'),
                    children: [t('item_1_3_desc1'), t('item_1_3_desc2')],
                },
            ],
        },
        {
            title: t('item_2_title'),
            children: [
                {
                    title: t('item_2_1_title'),
                    children: [t('item_2_1_desc1'), t('item_2_1_desc2'), t('item_2_1_desc3')],
                },
                {
                    title: t('item_2_2_title'),
                    children: [t('item_2_2_desc1'), t('item_2_2_desc2'), t('item_2_2_desc3')],
                },
                t('item2_3_desc'),
            ],
        },
    ];

    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [open]);
    return open
        ? createPortal(
              <div className={css.section}>
                  <div className="mask"></div>
                  <div className="body">
                      <div className="body-content">
                          <svg className="close" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none" onClick={onClose}>
                              <circle cx="10" cy="10" r="10" fill="white" fillOpacity="0.4" />
                              <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M8.76758 9.82812L6.46918 12.1265C6.17629 12.4194 6.17629 12.8943 6.46918 13.1872C6.76207 13.4801 7.23695 13.4801 7.52984 13.1872L9.82824 10.8888L12.1266 13.1872C12.4195 13.4801 12.8944 13.4801 13.1873 13.1872C13.4802 12.8943 13.4802 12.4194 13.1873 12.1265L10.8889 9.82812L13.1867 7.53033C13.4796 7.23744 13.4796 6.76256 13.1867 6.46967C12.8938 6.17678 12.4189 6.17678 12.126 6.46967L9.82824 8.76746L7.53045 6.46967C7.23755 6.17678 6.76268 6.17678 6.46979 6.46967C6.17689 6.76256 6.17689 7.23744 6.46979 7.53033L8.76758 9.82812Z"
                                  fill="white"
                              />
                          </svg>
                          <div className="title">{t('title')}</div>
                          <div className="content">
                              {list.map((i, idx) => (
                                  <div className="item-1" key={idx}>
                                      <div className="title-1">{i.title}</div>
                                      <div className="body-1">
                                          {i.children.map((j, idx2) =>
                                              typeof j === 'string' ? (
                                                  <div className="item-2 desc" key={`${idx}-${idx2}`}>
                                                      {j}
                                                  </div>
                                              ) : (
                                                  <div className="item-2" key={`${idx}-${idx2}`}>
                                                      <div className="title-2">{j.title}</div>
                                                      <ul className="body-2">
                                                          {j.children.map((k, idx3) => (
                                                              <li key={`${idx}-${idx2}-${idx3}`}>{k}</li>
                                                          ))}
                                                      </ul>
                                                  </div>
                                              ),
                                          )}
                                      </div>
                                  </div>
                              ))}
                          </div>
                      </div>
                  </div>
              </div>,
              document.body,
          )
        : null;
};
export default Dialog;
